import React, { useState, useEffect } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Row, Col, Card, Tabs, Input, DatePicker } from "antd";
import type { DatePickerProps } from "antd";
import { useAppDispatch } from "../../store/hooks";
import { userActions } from "../../store/user";
import ReferralLeaderList from "./user_components/ReferralLeaderList";

const formatDate = (date: Date) => date.toISOString().split("T")[0];

const calculateDate = (date: Date, tab: string) => {
  let start: Date;
  let end: Date;

  if (tab !== "1") {
    start = new Date(date);
    end = new Date(date);
    end.setDate(date.getDate() + 6);
  } else {
    end = new Date(date);
    end.setDate(date.getDate() - 1);
    start = new Date(end);
    start.setDate(end.getDate() - 6);
  }
  return {
    start_date: formatDate(start),
    end_date: formatDate(end),
  };
};

const Leaderboard = () => {
  const dispatch = useAppDispatch();
  const [leaderboardTab, setLeaderboardTab] = useState<string>("1");
  const [searchedText, setSearchedText] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [dateRange, setDateRange] = useState<{
    start_date: string;
    end_date: string;
  }>({
    start_date: calculateDate(new Date(), leaderboardTab).start_date,
    end_date: calculateDate(new Date(), leaderboardTab).end_date,
  });

  const onChnageSearchText = (val: string) => {
    setSearchedText(val);
  };

  const onDateChange: DatePickerProps["onChange"] = (date) => {
    if (date) {
      setSelectedDate(date.toDate());
      const newDateRange = calculateDate(date.toDate(), leaderboardTab);
      setDateRange(newDateRange);
    } else {
      const today = new Date();
      setSelectedDate(today);
      setDateRange(calculateDate(today, leaderboardTab));
    }
  };

  const onTabChange = (tab: string) => {
    setLeaderboardTab(tab);
    const newDateRange = calculateDate(selectedDate, tab);
    setDateRange(newDateRange);
  };

  useEffect(() => {
    dispatch(
      userActions.getTopReferralDetails({
        page: 1,
        pageSize: 10,
        search: searchedText,
        start_date: dateRange.start_date,
        end_date: dateRange.end_date,
      })
    );
  }, [dateRange, searchedText]);

  return (
    <Row className="row-gap">
      <Col span={24}>
        <Card
          title={
            <div className="user-tab-container">
              <Tabs
                defaultActiveKey={leaderboardTab}
                className="grey"
                onChange={(tab) => {
                  onTabChange(tab);
                }}
              >
                <Tabs.TabPane tab="Last Week" key={1} />
                <Tabs.TabPane tab="Current Week" key={2} />
              </Tabs>
              <div className="input-date-container">
                <Input
                  className="search-input"
                  onChange={(e) => onChnageSearchText(e.target.value)}
                  placeholder="search"
                  suffix={<SearchOutlined className="profile-text-color" />}
                ></Input>
                <DatePicker className="date-input" onChange={onDateChange} />
              </div>
            </div>
          }
          className={"transaction-card"}
        >
          <ReferralLeaderList dateRange={dateRange} />
        </Card>
      </Col>
    </Row>
  );
};

export default Leaderboard;
